import { createRoot } from 'react-dom/client'
import '~/@lib_integrations/translate-detection/patchDomForBrowserTranslate'
import '~/@lib_integrations/posthog/initPostHog'
import { addHubspotScript } from '~/@lib_integrations/analytics/hubspot'
import App from './App.tsx'
import './index.css'

addHubspotScript()

createRoot(document.getElementById('root')!).render(<App />)
